/* @generated from adl module ferovinum.app.workflow */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_db from './../../common/db';
import * as common_strings from './../../common/strings';
import * as ferovinum_app_common from './common';
import * as ferovinum_app_db from './db';
import * as ferovinum_app_deliveryoptions from './deliveryoptions';
import * as ferovinum_app_productsaleorder from './productsaleorder';
import * as ferovinum_app_systemcommand from './systemcommand';
import * as ferovinum_app_types from './types';
import * as sys_types from './../../sys/types';

export interface Workflow {
  state: WfState;
  data: WfData;
  actionableRoles: WfRole[];
  reference: common_strings.StringNE;
  history: WorkflowHistory[];
  organisationId: ferovinum_app_db.OrganisationId;
  workflowType: common_strings.StringNE;
  createdAt: common.Instant;
  parentId: (common_db.DbKey<Workflow>|null);
  stateCallbacks: sys_types.MapEntry<common_strings.StringNE, WfAction>[];
}

export function makeWorkflow(
  input: {
    state: WfState,
    data: WfData,
    actionableRoles: WfRole[],
    reference: common_strings.StringNE,
    history: WorkflowHistory[],
    organisationId: ferovinum_app_db.OrganisationId,
    workflowType: common_strings.StringNE,
    createdAt: common.Instant,
    parentId: (common_db.DbKey<Workflow>|null),
    stateCallbacks: sys_types.MapEntry<common_strings.StringNE, WfAction>[],
  }
): Workflow {
  return {
    state: input.state,
    data: input.data,
    actionableRoles: input.actionableRoles,
    reference: input.reference,
    history: input.history,
    organisationId: input.organisationId,
    workflowType: input.workflowType,
    createdAt: input.createdAt,
    parentId: input.parentId,
    stateCallbacks: input.stateCallbacks,
  };
}

const Workflow_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[{"value":{"withIdPrimaryKey":true,"label":["reference"],"uniquenessConstraints":[["reference","workflowType"]]},"key":{"moduleName":"common.db","name":"DbTable"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"state","default":{"kind":"nothing"},"name":"state","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"WfState"}},"parameters":[]}},{"annotations":[],"serializedName":"data","default":{"kind":"nothing"},"name":"data","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"WfData"}},"parameters":[]}},{"annotations":[],"serializedName":"actionableRoles","default":{"kind":"nothing"},"name":"actionableRoles","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"WfRole"}},"parameters":[]}]}},{"annotations":[],"serializedName":"reference","default":{"kind":"nothing"},"name":"reference","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"history","default":{"kind":"nothing"},"name":"history","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"WorkflowHistory"}},"parameters":[]}]}},{"annotations":[],"serializedName":"organisationId","default":{"kind":"nothing"},"name":"organisationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"OrganisationId"}},"parameters":[]}},{"annotations":[],"serializedName":"workflowType","default":{"kind":"nothing"},"name":"workflowType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"createdAt","default":{"kind":"nothing"},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"parentId","default":{"kind":"nothing"},"name":"parentId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"Workflow"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"stateCallbacks","default":{"kind":"nothing"},"name":"stateCallbacks","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"sys.types","name":"MapEntry"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"WfAction"}},"parameters":[]}]}]}}]}},"name":"Workflow","version":{"kind":"nothing"}}};

export const snWorkflow: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"Workflow"};

export function texprWorkflow(): ADL.ATypeExpr<Workflow> {
  return {value : {typeRef : {kind: "reference", value : snWorkflow}, parameters : []}};
}

export type WorkflowId = common_db.DbKey<Workflow>;

const WorkflowId_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"Workflow"}},"parameters":[]}]}}},"name":"WorkflowId","version":{"kind":"nothing"}}};

export const snWorkflowId: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"WorkflowId"};

export function texprWorkflowId(): ADL.ATypeExpr<WorkflowId> {
  return {value : {typeRef : {kind: "reference", value : snWorkflowId}, parameters : []}};
}

export interface WorkflowHistory {
  prevState: (WfState|null);
  action: WfAction;
  systemCommands: ferovinum_app_systemcommand.SystemCmd[];
  timestamp: common.Instant;
}

export function makeWorkflowHistory(
  input: {
    prevState: (WfState|null),
    action: WfAction,
    systemCommands: ferovinum_app_systemcommand.SystemCmd[],
    timestamp: common.Instant,
  }
): WorkflowHistory {
  return {
    prevState: input.prevState,
    action: input.action,
    systemCommands: input.systemCommands,
    timestamp: input.timestamp,
  };
}

const WorkflowHistory_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"prevState","default":{"kind":"nothing"},"name":"prevState","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"WfState"}},"parameters":[]}]}},{"annotations":[],"serializedName":"action","default":{"kind":"nothing"},"name":"action","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"WfAction"}},"parameters":[]}},{"annotations":[],"serializedName":"systemCommands","default":{"kind":"nothing"},"name":"systemCommands","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.systemcommand","name":"SystemCmd"}},"parameters":[]}]}},{"annotations":[],"serializedName":"timestamp","default":{"kind":"nothing"},"name":"timestamp","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"WorkflowHistory","version":{"kind":"nothing"}}};

export const snWorkflowHistory: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"WorkflowHistory"};

export function texprWorkflowHistory(): ADL.ATypeExpr<WorkflowHistory> {
  return {value : {typeRef : {kind: "reference", value : snWorkflowHistory}, parameters : []}};
}

export type WfRole = 'carrier' | 'client_org' | 'fero_admin' | 'purchaser' | 'storage_location' | 'supplier';
export const valuesWfRole : WfRole[] = ['carrier', 'client_org', 'fero_admin', 'purchaser', 'storage_location', 'supplier'];

const WfRole_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"carrier","default":{"kind":"nothing"},"name":"carrier","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"client_org","default":{"kind":"nothing"},"name":"client_org","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"fero_admin","default":{"kind":"nothing"},"name":"fero_admin","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"purchaser","default":{"kind":"nothing"},"name":"purchaser","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"storage_location","default":{"kind":"nothing"},"name":"storage_location","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"supplier","default":{"kind":"nothing"},"name":"supplier","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"WfRole","version":{"kind":"nothing"}}};

export const snWfRole: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"WfRole"};

export function texprWfRole(): ADL.ATypeExpr<WfRole> {
  return {value : {typeRef : {kind: "reference", value : snWfRole}, parameters : []}};
}

export interface WfData_Stock_movement {
  kind: 'stock_movement';
  value: StockMovementWfData;
}
export interface WfData_Transport {
  kind: 'transport';
  value: TransportWfData;
}
export interface WfData_Stock_gain {
  kind: 'stock_gain';
  value: StockGainWfData;
}
export interface WfData_Stock_loss {
  kind: 'stock_loss';
  value: StockLossWfData;
}
export interface WfData_Buy_back {
  kind: 'buy_back';
  value: BuybackWfData;
}

export type WfData = WfData_Stock_movement | WfData_Transport | WfData_Stock_gain | WfData_Stock_loss | WfData_Buy_back;

export interface WfDataOpts {
  stock_movement: StockMovementWfData;
  transport: TransportWfData;
  stock_gain: StockGainWfData;
  stock_loss: StockLossWfData;
  buy_back: BuybackWfData;
}

export function makeWfData<K extends keyof WfDataOpts>(kind: K, value: WfDataOpts[K]) { return {kind, value}; }

const WfData_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"stock_movement","default":{"kind":"nothing"},"name":"stock_movement","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"StockMovementWfData"}},"parameters":[]}},{"annotations":[],"serializedName":"transport","default":{"kind":"nothing"},"name":"transport","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"TransportWfData"}},"parameters":[]}},{"annotations":[],"serializedName":"stock_gain","default":{"kind":"nothing"},"name":"stock_gain","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"StockGainWfData"}},"parameters":[]}},{"annotations":[],"serializedName":"stock_loss","default":{"kind":"nothing"},"name":"stock_loss","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"StockLossWfData"}},"parameters":[]}},{"annotations":[],"serializedName":"buy_back","default":{"kind":"nothing"},"name":"buy_back","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"BuybackWfData"}},"parameters":[]}}]}},"name":"WfData","version":{"kind":"nothing"}}};

export const snWfData: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"WfData"};

export function texprWfData(): ADL.ATypeExpr<WfData> {
  return {value : {typeRef : {kind: "reference", value : snWfData}, parameters : []}};
}

export interface WfState_Stock_movement {
  kind: 'stock_movement';
  value: StockMovementWfState;
}
export interface WfState_Transport {
  kind: 'transport';
  value: TransportWfState;
}
export interface WfState_Stock_gain {
  kind: 'stock_gain';
  value: StockGainWfState;
}
export interface WfState_Stock_loss {
  kind: 'stock_loss';
  value: StockLossWfState;
}
export interface WfState_Buy_back {
  kind: 'buy_back';
  value: BuybackWfState;
}

export type WfState = WfState_Stock_movement | WfState_Transport | WfState_Stock_gain | WfState_Stock_loss | WfState_Buy_back;

export interface WfStateOpts {
  stock_movement: StockMovementWfState;
  transport: TransportWfState;
  stock_gain: StockGainWfState;
  stock_loss: StockLossWfState;
  buy_back: BuybackWfState;
}

export function makeWfState<K extends keyof WfStateOpts>(kind: K, value: WfStateOpts[K]) { return {kind, value}; }

const WfState_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"stock_movement","default":{"kind":"nothing"},"name":"stock_movement","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"StockMovementWfState"}},"parameters":[]}},{"annotations":[],"serializedName":"transport","default":{"kind":"nothing"},"name":"transport","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"TransportWfState"}},"parameters":[]}},{"annotations":[],"serializedName":"stock_gain","default":{"kind":"nothing"},"name":"stock_gain","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"StockGainWfState"}},"parameters":[]}},{"annotations":[],"serializedName":"stock_loss","default":{"kind":"nothing"},"name":"stock_loss","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"StockLossWfState"}},"parameters":[]}},{"annotations":[],"serializedName":"buy_back","default":{"kind":"nothing"},"name":"buy_back","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"BuybackWfState"}},"parameters":[]}}]}},"name":"WfState","version":{"kind":"nothing"}}};

export const snWfState: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"WfState"};

export function texprWfState(): ADL.ATypeExpr<WfState> {
  return {value : {typeRef : {kind: "reference", value : snWfState}, parameters : []}};
}

export interface WfAction_Stock_movement {
  kind: 'stock_movement';
  value: StockMovementWfAction;
}
export interface WfAction_Transport {
  kind: 'transport';
  value: TransportWfAction;
}
export interface WfAction_Stock_gain {
  kind: 'stock_gain';
  value: StockGainWfAction;
}
export interface WfAction_Stock_loss {
  kind: 'stock_loss';
  value: StockLossWfAction;
}
export interface WfAction_Buy_back {
  kind: 'buy_back';
  value: BuybackWfAction;
}

export type WfAction = WfAction_Stock_movement | WfAction_Transport | WfAction_Stock_gain | WfAction_Stock_loss | WfAction_Buy_back;

export interface WfActionOpts {
  stock_movement: StockMovementWfAction;
  transport: TransportWfAction;
  stock_gain: StockGainWfAction;
  stock_loss: StockLossWfAction;
  buy_back: BuybackWfAction;
}

export function makeWfAction<K extends keyof WfActionOpts>(kind: K, value: WfActionOpts[K]) { return {kind, value}; }

const WfAction_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"stock_movement","default":{"kind":"nothing"},"name":"stock_movement","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"StockMovementWfAction"}},"parameters":[]}},{"annotations":[],"serializedName":"transport","default":{"kind":"nothing"},"name":"transport","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"TransportWfAction"}},"parameters":[]}},{"annotations":[],"serializedName":"stock_gain","default":{"kind":"nothing"},"name":"stock_gain","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"StockGainWfAction"}},"parameters":[]}},{"annotations":[],"serializedName":"stock_loss","default":{"kind":"nothing"},"name":"stock_loss","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"StockLossWfAction"}},"parameters":[]}},{"annotations":[],"serializedName":"buy_back","default":{"kind":"nothing"},"name":"buy_back","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"BuybackWfAction"}},"parameters":[]}}]}},"name":"WfAction","version":{"kind":"nothing"}}};

export const snWfAction: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"WfAction"};

export function texprWfAction(): ADL.ATypeExpr<WfAction> {
  return {value : {typeRef : {kind: "reference", value : snWfAction}, parameters : []}};
}

export interface WfSuccessResult {
  workflowId: common_db.DbKey<Workflow>;
  state: WfState;
  context: string;
}

export function makeWfSuccessResult(
  input: {
    workflowId: common_db.DbKey<Workflow>,
    state: WfState,
    context?: string,
  }
): WfSuccessResult {
  return {
    workflowId: input.workflowId,
    state: input.state,
    context: input.context === undefined ? "" : input.context,
  };
}

const WfSuccessResult_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"workflowId","default":{"kind":"nothing"},"name":"workflowId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"Workflow"}},"parameters":[]}]}},{"annotations":[],"serializedName":"state","default":{"kind":"nothing"},"name":"state","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"WfState"}},"parameters":[]}},{"annotations":[],"serializedName":"context","default":{"kind":"just","value":""},"name":"context","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"WfSuccessResult","version":{"kind":"nothing"}}};

export const snWfSuccessResult: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"WfSuccessResult"};

export function texprWfSuccessResult(): ADL.ATypeExpr<WfSuccessResult> {
  return {value : {typeRef : {kind: "reference", value : snWfSuccessResult}, parameters : []}};
}

export interface WfResult_Success {
  kind: 'success';
  value: WfSuccessResult;
}
export interface WfResult_Error {
  kind: 'error';
  value: WfError;
}
export interface WfResult_Not_permitted {
  kind: 'not_permitted';
}

export type WfResult = WfResult_Success | WfResult_Error | WfResult_Not_permitted;

export interface WfResultOpts {
  success: WfSuccessResult;
  error: WfError;
  not_permitted: null;
}

export function makeWfResult<K extends keyof WfResultOpts>(kind: K, value: WfResultOpts[K]) { return {kind, value}; }

const WfResult_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"success","default":{"kind":"nothing"},"name":"success","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"WfSuccessResult"}},"parameters":[]}},{"annotations":[],"serializedName":"error","default":{"kind":"nothing"},"name":"error","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"WfError"}},"parameters":[]}},{"annotations":[],"serializedName":"not_permitted","default":{"kind":"nothing"},"name":"not_permitted","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"WfResult","version":{"kind":"nothing"}}};

export const snWfResult: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"WfResult"};

export function texprWfResult(): ADL.ATypeExpr<WfResult> {
  return {value : {typeRef : {kind: "reference", value : snWfResult}, parameters : []}};
}

export interface WfError {
  from: string;
  errorMsg: string;
  errorCode: string;
  context: string;
}

export function makeWfError(
  input: {
    from: string,
    errorMsg: string,
    errorCode?: string,
    context?: string,
  }
): WfError {
  return {
    from: input.from,
    errorMsg: input.errorMsg,
    errorCode: input.errorCode === undefined ? "UNKNOWN" : input.errorCode,
    context: input.context === undefined ? "" : input.context,
  };
}

const WfError_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"from","default":{"kind":"nothing"},"name":"from","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"errorMsg","default":{"kind":"nothing"},"name":"errorMsg","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"errorCode","default":{"kind":"just","value":"UNKNOWN"},"name":"errorCode","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"context","default":{"kind":"just","value":""},"name":"context","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"WfError","version":{"kind":"nothing"}}};

export const snWfError: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"WfError"};

export function texprWfError(): ADL.ATypeExpr<WfError> {
  return {value : {typeRef : {kind: "reference", value : snWfError}, parameters : []}};
}

export interface StockMovementDeliveryOption_CollectionByOrg {
  kind: 'collectionByOrg';
  value: StockMovementCollection;
}
export interface StockMovementDeliveryOption_OrganisedDelivery {
  kind: 'organisedDelivery';
  value: StockMovementDelivery;
}

export type StockMovementDeliveryOption = StockMovementDeliveryOption_CollectionByOrg | StockMovementDeliveryOption_OrganisedDelivery;

export interface StockMovementDeliveryOptionOpts {
  collectionByOrg: StockMovementCollection;
  organisedDelivery: StockMovementDelivery;
}

export function makeStockMovementDeliveryOption<K extends keyof StockMovementDeliveryOptionOpts>(kind: K, value: StockMovementDeliveryOptionOpts[K]) { return {kind, value}; }

const StockMovementDeliveryOption_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"collectionByOrg","default":{"kind":"nothing"},"name":"collectionByOrg","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"StockMovementCollection"}},"parameters":[]}},{"annotations":[],"serializedName":"organisedDelivery","default":{"kind":"nothing"},"name":"organisedDelivery","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"StockMovementDelivery"}},"parameters":[]}}]}},"name":"StockMovementDeliveryOption","version":{"kind":"nothing"}}};

export const snStockMovementDeliveryOption: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"StockMovementDeliveryOption"};

export function texprStockMovementDeliveryOption(): ADL.ATypeExpr<StockMovementDeliveryOption> {
  return {value : {typeRef : {kind: "reference", value : snStockMovementDeliveryOption}, parameters : []}};
}

export interface StockMovementCollection {
  collectionDate: common.LocalDate;
  collectionTime: common.LocalTime;
  deliveryDate: common.LocalDate;
  carrierName: string;
  contactName: string;
  contactEmail: string;
  contactNumber: string;
  vehicleRegistration: (string|null);
  movementGuaranteeNumber: (string|null);
}

export function makeStockMovementCollection(
  input: {
    collectionDate: common.LocalDate,
    collectionTime: common.LocalTime,
    deliveryDate: common.LocalDate,
    carrierName: string,
    contactName: string,
    contactEmail: string,
    contactNumber: string,
    vehicleRegistration: (string|null),
    movementGuaranteeNumber?: (string|null),
  }
): StockMovementCollection {
  return {
    collectionDate: input.collectionDate,
    collectionTime: input.collectionTime,
    deliveryDate: input.deliveryDate,
    carrierName: input.carrierName,
    contactName: input.contactName,
    contactEmail: input.contactEmail,
    contactNumber: input.contactNumber,
    vehicleRegistration: input.vehicleRegistration,
    movementGuaranteeNumber: input.movementGuaranteeNumber === undefined ? null : input.movementGuaranteeNumber,
  };
}

const StockMovementCollection_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"collectionDate","default":{"kind":"nothing"},"name":"collectionDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"collectionTime","default":{"kind":"nothing"},"name":"collectionTime","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalTime"}},"parameters":[]}},{"annotations":[],"serializedName":"deliveryDate","default":{"kind":"nothing"},"name":"deliveryDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"carrierName","default":{"kind":"nothing"},"name":"carrierName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"contactName","default":{"kind":"nothing"},"name":"contactName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"contactEmail","default":{"kind":"nothing"},"name":"contactEmail","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"contactNumber","default":{"kind":"nothing"},"name":"contactNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"vehicleRegistration","default":{"kind":"nothing"},"name":"vehicleRegistration","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"movementGuaranteeNumber","default":{"kind":"just","value":null},"name":"movementGuaranteeNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}]}},"name":"StockMovementCollection","version":{"kind":"nothing"}}};

export const snStockMovementCollection: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"StockMovementCollection"};

export function texprStockMovementCollection(): ADL.ATypeExpr<StockMovementCollection> {
  return {value : {typeRef : {kind: "reference", value : snStockMovementCollection}, parameters : []}};
}

export interface StockMovementDelivery {
  carrier: ferovinum_app_db.CarrierId;
  deliveryDate: common.LocalDate;
  deliveryTimeEarliest: common.LocalTime;
  deliveryTimeLatest: common.LocalTime;
  deliveryInstructions: (string|null);
}

export function makeStockMovementDelivery(
  input: {
    carrier: ferovinum_app_db.CarrierId,
    deliveryDate: common.LocalDate,
    deliveryTimeEarliest: common.LocalTime,
    deliveryTimeLatest: common.LocalTime,
    deliveryInstructions: (string|null),
  }
): StockMovementDelivery {
  return {
    carrier: input.carrier,
    deliveryDate: input.deliveryDate,
    deliveryTimeEarliest: input.deliveryTimeEarliest,
    deliveryTimeLatest: input.deliveryTimeLatest,
    deliveryInstructions: input.deliveryInstructions,
  };
}

const StockMovementDelivery_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"carrier","default":{"kind":"nothing"},"name":"carrier","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"CarrierId"}},"parameters":[]}},{"annotations":[],"serializedName":"deliveryDate","default":{"kind":"nothing"},"name":"deliveryDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"deliveryTimeEarliest","default":{"kind":"nothing"},"name":"deliveryTimeEarliest","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalTime"}},"parameters":[]}},{"annotations":[],"serializedName":"deliveryTimeLatest","default":{"kind":"nothing"},"name":"deliveryTimeLatest","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalTime"}},"parameters":[]}},{"annotations":[],"serializedName":"deliveryInstructions","default":{"kind":"nothing"},"name":"deliveryInstructions","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}]}},"name":"StockMovementDelivery","version":{"kind":"nothing"}}};

export const snStockMovementDelivery: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"StockMovementDelivery"};

export function texprStockMovementDelivery(): ADL.ATypeExpr<StockMovementDelivery> {
  return {value : {typeRef : {kind: "reference", value : snStockMovementDelivery}, parameters : []}};
}

export interface StockMovementReq {
  orgId: ferovinum_app_db.OrganisationId;
  startingLocationId: ferovinum_app_db.StorageLocationId;
  destinationLocationId: ferovinum_app_db.StorageLocationId;
  stockToMove: ferovinum_app_common.ProductIdQuantity[];
  stockMovementDeliveryOption: StockMovementDeliveryOption;
}

export function makeStockMovementReq(
  input: {
    orgId: ferovinum_app_db.OrganisationId,
    startingLocationId: ferovinum_app_db.StorageLocationId,
    destinationLocationId: ferovinum_app_db.StorageLocationId,
    stockToMove: ferovinum_app_common.ProductIdQuantity[],
    stockMovementDeliveryOption: StockMovementDeliveryOption,
  }
): StockMovementReq {
  return {
    orgId: input.orgId,
    startingLocationId: input.startingLocationId,
    destinationLocationId: input.destinationLocationId,
    stockToMove: input.stockToMove,
    stockMovementDeliveryOption: input.stockMovementDeliveryOption,
  };
}

const StockMovementReq_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"orgId","default":{"kind":"nothing"},"name":"orgId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"OrganisationId"}},"parameters":[]}},{"annotations":[],"serializedName":"startingLocationId","default":{"kind":"nothing"},"name":"startingLocationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"StorageLocationId"}},"parameters":[]}},{"annotations":[],"serializedName":"destinationLocationId","default":{"kind":"nothing"},"name":"destinationLocationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"StorageLocationId"}},"parameters":[]}},{"annotations":[],"serializedName":"stockToMove","default":{"kind":"nothing"},"name":"stockToMove","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.common","name":"ProductIdQuantity"}},"parameters":[]}]}},{"annotations":[],"serializedName":"stockMovementDeliveryOption","default":{"kind":"nothing"},"name":"stockMovementDeliveryOption","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"StockMovementDeliveryOption"}},"parameters":[]}}]}},"name":"StockMovementReq","version":{"kind":"nothing"}}};

export const snStockMovementReq: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"StockMovementReq"};

export function texprStockMovementReq(): ADL.ATypeExpr<StockMovementReq> {
  return {value : {typeRef : {kind: "reference", value : snStockMovementReq}, parameters : []}};
}

export interface StockMovementWfData {
  request: StockMovementReq;
  saleOrderId: (ferovinum_app_db.SaleOrderId|null);
  createdDealLegs: (ferovinum_app_db.DealLegId[]|null);
  processId: common_strings.StringNE;
  reservedId: (common_strings.StringNE|null);
  releasedId: (common_strings.StringNE|null);
  expectedId: (common_strings.StringNE|null);
}

export function makeStockMovementWfData(
  input: {
    request: StockMovementReq,
    saleOrderId: (ferovinum_app_db.SaleOrderId|null),
    createdDealLegs: (ferovinum_app_db.DealLegId[]|null),
    processId?: common_strings.StringNE,
    reservedId?: (common_strings.StringNE|null),
    releasedId?: (common_strings.StringNE|null),
    expectedId?: (common_strings.StringNE|null),
  }
): StockMovementWfData {
  return {
    request: input.request,
    saleOrderId: input.saleOrderId,
    createdDealLegs: input.createdDealLegs,
    processId: input.processId === undefined ? "STOCK_MOVEMENT" : input.processId,
    reservedId: input.reservedId === undefined ? null : input.reservedId,
    releasedId: input.releasedId === undefined ? null : input.releasedId,
    expectedId: input.expectedId === undefined ? null : input.expectedId,
  };
}

const StockMovementWfData_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"request","default":{"kind":"nothing"},"name":"request","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"StockMovementReq"}},"parameters":[]}},{"annotations":[],"serializedName":"saleOrderId","default":{"kind":"nothing"},"name":"saleOrderId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"SaleOrderId"}},"parameters":[]}]}},{"annotations":[],"serializedName":"createdDealLegs","default":{"kind":"nothing"},"name":"createdDealLegs","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"DealLegId"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"processId","default":{"kind":"just","value":"STOCK_MOVEMENT"},"name":"processId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"reservedId","default":{"kind":"just","value":null},"name":"reservedId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"releasedId","default":{"kind":"just","value":null},"name":"releasedId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"expectedId","default":{"kind":"just","value":null},"name":"expectedId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}}]}},"name":"StockMovementWfData","version":{"kind":"nothing"}}};

export const snStockMovementWfData: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"StockMovementWfData"};

export function texprStockMovementWfData(): ADL.ATypeExpr<StockMovementWfData> {
  return {value : {typeRef : {kind: "reference", value : snStockMovementWfData}, parameters : []}};
}

export type StockMovementWfState = 'requested' | 'approved' | 'rejected' | 'cancelled' | 'completed';
export const valuesStockMovementWfState : StockMovementWfState[] = ['requested', 'approved', 'rejected', 'cancelled', 'completed'];

const StockMovementWfState_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"requested","default":{"kind":"nothing"},"name":"requested","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"approved","default":{"kind":"nothing"},"name":"approved","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"rejected","default":{"kind":"nothing"},"name":"rejected","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"cancelled","default":{"kind":"nothing"},"name":"cancelled","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"completed","default":{"kind":"nothing"},"name":"completed","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"StockMovementWfState","version":{"kind":"nothing"}}};

export const snStockMovementWfState: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"StockMovementWfState"};

export function texprStockMovementWfState(): ADL.ATypeExpr<StockMovementWfState> {
  return {value : {typeRef : {kind: "reference", value : snStockMovementWfState}, parameters : []}};
}

export interface StockMovementWfAction_Request {
  kind: 'request';
  value: StockMovementReq;
}
export interface StockMovementWfAction_Approve {
  kind: 'approve';
}
export interface StockMovementWfAction_Reject {
  kind: 'reject';
}
export interface StockMovementWfAction_Cancel {
  kind: 'cancel';
}
export interface StockMovementWfAction_Complete {
  kind: 'complete';
}

export type StockMovementWfAction = StockMovementWfAction_Request | StockMovementWfAction_Approve | StockMovementWfAction_Reject | StockMovementWfAction_Cancel | StockMovementWfAction_Complete;

export interface StockMovementWfActionOpts {
  request: StockMovementReq;
  approve: null;
  reject: null;
  cancel: null;
  complete: null;
}

export function makeStockMovementWfAction<K extends keyof StockMovementWfActionOpts>(kind: K, value: StockMovementWfActionOpts[K]) { return {kind, value}; }

const StockMovementWfAction_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"request","default":{"kind":"nothing"},"name":"request","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"StockMovementReq"}},"parameters":[]}},{"annotations":[],"serializedName":"approve","default":{"kind":"nothing"},"name":"approve","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"reject","default":{"kind":"nothing"},"name":"reject","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"cancel","default":{"kind":"nothing"},"name":"cancel","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"complete","default":{"kind":"nothing"},"name":"complete","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"StockMovementWfAction","version":{"kind":"nothing"}}};

export const snStockMovementWfAction: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"StockMovementWfAction"};

export function texprStockMovementWfAction(): ADL.ATypeExpr<StockMovementWfAction> {
  return {value : {typeRef : {kind: "reference", value : snStockMovementWfAction}, parameters : []}};
}

export interface BuybackOption_CollectionByOrg {
  kind: 'collectionByOrg';
  value: BuybackCollection;
}

export type BuybackOption = BuybackOption_CollectionByOrg;

export interface BuybackOptionOpts {
  collectionByOrg: BuybackCollection;
}

export function makeBuybackOption<K extends keyof BuybackOptionOpts>(kind: K, value: BuybackOptionOpts[K]) { return {kind, value}; }

const BuybackOption_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"collectionByOrg","default":{"kind":"nothing"},"name":"collectionByOrg","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"BuybackCollection"}},"parameters":[]}}]}},"name":"BuybackOption","version":{"kind":"nothing"}}};

export const snBuybackOption: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"BuybackOption"};

export function texprBuybackOption(): ADL.ATypeExpr<BuybackOption> {
  return {value : {typeRef : {kind: "reference", value : snBuybackOption}, parameters : []}};
}

export interface BuybackCollection {
  collectionDate: common.LocalDate;
}

export function makeBuybackCollection(
  input: {
    collectionDate: common.LocalDate,
  }
): BuybackCollection {
  return {
    collectionDate: input.collectionDate,
  };
}

const BuybackCollection_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"collectionDate","default":{"kind":"nothing"},"name":"collectionDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}}]}},"name":"BuybackCollection","version":{"kind":"nothing"}}};

export const snBuybackCollection: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"BuybackCollection"};

export function texprBuybackCollection(): ADL.ATypeExpr<BuybackCollection> {
  return {value : {typeRef : {kind: "reference", value : snBuybackCollection}, parameters : []}};
}

export interface BuybackReq {
  organisationId: ferovinum_app_db.OrganisationId;
  storageLocationId: ferovinum_app_db.StorageLocationId;
  deliveryOption: ferovinum_app_deliveryoptions.DeliveryOptionReq;
  productsSaleOrders: ferovinum_app_productsaleorder.ProductSaleOrder[];
  useCredit: boolean;
  allowPartialCasks: boolean;
}

export function makeBuybackReq(
  input: {
    organisationId: ferovinum_app_db.OrganisationId,
    storageLocationId: ferovinum_app_db.StorageLocationId,
    deliveryOption: ferovinum_app_deliveryoptions.DeliveryOptionReq,
    productsSaleOrders: ferovinum_app_productsaleorder.ProductSaleOrder[],
    useCredit: boolean,
    allowPartialCasks: boolean,
  }
): BuybackReq {
  return {
    organisationId: input.organisationId,
    storageLocationId: input.storageLocationId,
    deliveryOption: input.deliveryOption,
    productsSaleOrders: input.productsSaleOrders,
    useCredit: input.useCredit,
    allowPartialCasks: input.allowPartialCasks,
  };
}

const BuybackReq_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"organisationId","default":{"kind":"nothing"},"name":"organisationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"OrganisationId"}},"parameters":[]}},{"annotations":[],"serializedName":"storageLocationId","default":{"kind":"nothing"},"name":"storageLocationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"StorageLocationId"}},"parameters":[]}},{"annotations":[],"serializedName":"deliveryOption","default":{"kind":"nothing"},"name":"deliveryOption","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.deliveryoptions","name":"DeliveryOptionReq"}},"parameters":[]}},{"annotations":[],"serializedName":"productsSaleOrders","default":{"kind":"nothing"},"name":"productsSaleOrders","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.productsaleorder","name":"ProductSaleOrder"}},"parameters":[]}]}},{"annotations":[],"serializedName":"useCredit","default":{"kind":"nothing"},"name":"useCredit","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"allowPartialCasks","default":{"kind":"nothing"},"name":"allowPartialCasks","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"BuybackReq","version":{"kind":"nothing"}}};

export const snBuybackReq: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"BuybackReq"};

export function texprBuybackReq(): ADL.ATypeExpr<BuybackReq> {
  return {value : {typeRef : {kind: "reference", value : snBuybackReq}, parameters : []}};
}

export interface BuybackCreateFromExistingReq {
  saleOrderId: ferovinum_app_db.SaleOrderId;
}

export function makeBuybackCreateFromExistingReq(
  input: {
    saleOrderId: ferovinum_app_db.SaleOrderId,
  }
): BuybackCreateFromExistingReq {
  return {
    saleOrderId: input.saleOrderId,
  };
}

const BuybackCreateFromExistingReq_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"saleOrderId","default":{"kind":"nothing"},"name":"saleOrderId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"SaleOrderId"}},"parameters":[]}}]}},"name":"BuybackCreateFromExistingReq","version":{"kind":"nothing"}}};

export const snBuybackCreateFromExistingReq: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"BuybackCreateFromExistingReq"};

export function texprBuybackCreateFromExistingReq(): ADL.ATypeExpr<BuybackCreateFromExistingReq> {
  return {value : {typeRef : {kind: "reference", value : snBuybackCreateFromExistingReq}, parameters : []}};
}

export interface BuybackMarkAsInvoicedReq {
  invoiceNumber: string;
}

export function makeBuybackMarkAsInvoicedReq(
  input: {
    invoiceNumber: string,
  }
): BuybackMarkAsInvoicedReq {
  return {
    invoiceNumber: input.invoiceNumber,
  };
}

const BuybackMarkAsInvoicedReq_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"invoiceNumber","default":{"kind":"nothing"},"name":"invoiceNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"BuybackMarkAsInvoicedReq","version":{"kind":"nothing"}}};

export const snBuybackMarkAsInvoicedReq: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"BuybackMarkAsInvoicedReq"};

export function texprBuybackMarkAsInvoicedReq(): ADL.ATypeExpr<BuybackMarkAsInvoicedReq> {
  return {value : {typeRef : {kind: "reference", value : snBuybackMarkAsInvoicedReq}, parameters : []}};
}

export interface BuybackWfData {
  saleOrderId: ferovinum_app_db.SaleOrderId;
}

export function makeBuybackWfData(
  input: {
    saleOrderId: ferovinum_app_db.SaleOrderId,
  }
): BuybackWfData {
  return {
    saleOrderId: input.saleOrderId,
  };
}

const BuybackWfData_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"saleOrderId","default":{"kind":"nothing"},"name":"saleOrderId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"SaleOrderId"}},"parameters":[]}}]}},"name":"BuybackWfData","version":{"kind":"nothing"}}};

export const snBuybackWfData: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"BuybackWfData"};

export function texprBuybackWfData(): ADL.ATypeExpr<BuybackWfData> {
  return {value : {typeRef : {kind: "reference", value : snBuybackWfData}, parameters : []}};
}

export type BuybackWfState = 'created' | 'awaiting_cash_payment' | 'delivery_order_requested' | 'financing_checkpoint' | 'release_checkpoint' | 'awaiting_release' | 'awaiting_credit_payment' | 'released' | 'completed' | 'cancelled';
export const valuesBuybackWfState : BuybackWfState[] = ['created', 'awaiting_cash_payment', 'delivery_order_requested', 'financing_checkpoint', 'release_checkpoint', 'awaiting_release', 'awaiting_credit_payment', 'released', 'completed', 'cancelled'];

const BuybackWfState_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"created","default":{"kind":"nothing"},"name":"created","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"awaiting_cash_payment","default":{"kind":"nothing"},"name":"awaiting_cash_payment","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"delivery_order_requested","default":{"kind":"nothing"},"name":"delivery_order_requested","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"financing_checkpoint","default":{"kind":"nothing"},"name":"financing_checkpoint","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"release_checkpoint","default":{"kind":"nothing"},"name":"release_checkpoint","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"awaiting_release","default":{"kind":"nothing"},"name":"awaiting_release","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"awaiting_credit_payment","default":{"kind":"nothing"},"name":"awaiting_credit_payment","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"released","default":{"kind":"nothing"},"name":"released","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"completed","default":{"kind":"nothing"},"name":"completed","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"cancelled","default":{"kind":"nothing"},"name":"cancelled","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"BuybackWfState","version":{"kind":"nothing"}}};

export const snBuybackWfState: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"BuybackWfState"};

export function texprBuybackWfState(): ADL.ATypeExpr<BuybackWfState> {
  return {value : {typeRef : {kind: "reference", value : snBuybackWfState}, parameters : []}};
}

export interface BuybackWfAction_Request {
  kind: 'request';
  value: BuybackReq;
}
export interface BuybackWfAction_Create_from_existing {
  kind: 'create_from_existing';
  value: BuybackCreateFromExistingReq;
}
export interface BuybackWfAction_Mark_as_invoiced {
  kind: 'mark_as_invoiced';
  value: BuybackMarkAsInvoicedReq;
}
export interface BuybackWfAction_Mark_as_delivery_order_signoff {
  kind: 'mark_as_delivery_order_signoff';
}
export interface BuybackWfAction_Mark_as_paid {
  kind: 'mark_as_paid';
}
export interface BuybackWfAction_Release {
  kind: 'release';
}
export interface BuybackWfAction_Cancel {
  kind: 'cancel';
}
export interface BuybackWfAction_Auto_progress {
  kind: 'auto_progress';
}

export type BuybackWfAction = BuybackWfAction_Request | BuybackWfAction_Create_from_existing | BuybackWfAction_Mark_as_invoiced | BuybackWfAction_Mark_as_delivery_order_signoff | BuybackWfAction_Mark_as_paid | BuybackWfAction_Release | BuybackWfAction_Cancel | BuybackWfAction_Auto_progress;

export interface BuybackWfActionOpts {
  request: BuybackReq;
  create_from_existing: BuybackCreateFromExistingReq;
  mark_as_invoiced: BuybackMarkAsInvoicedReq;
  mark_as_delivery_order_signoff: null;
  mark_as_paid: null;
  release: null;
  cancel: null;
  auto_progress: null;
}

export function makeBuybackWfAction<K extends keyof BuybackWfActionOpts>(kind: K, value: BuybackWfActionOpts[K]) { return {kind, value}; }

const BuybackWfAction_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"request","default":{"kind":"nothing"},"name":"request","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"BuybackReq"}},"parameters":[]}},{"annotations":[],"serializedName":"create_from_existing","default":{"kind":"nothing"},"name":"create_from_existing","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"BuybackCreateFromExistingReq"}},"parameters":[]}},{"annotations":[],"serializedName":"mark_as_invoiced","default":{"kind":"nothing"},"name":"mark_as_invoiced","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"BuybackMarkAsInvoicedReq"}},"parameters":[]}},{"annotations":[],"serializedName":"mark_as_delivery_order_signoff","default":{"kind":"nothing"},"name":"mark_as_delivery_order_signoff","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"mark_as_paid","default":{"kind":"nothing"},"name":"mark_as_paid","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"release","default":{"kind":"nothing"},"name":"release","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"cancel","default":{"kind":"nothing"},"name":"cancel","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"auto_progress","default":{"kind":"nothing"},"name":"auto_progress","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"BuybackWfAction","version":{"kind":"nothing"}}};

export const snBuybackWfAction: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"BuybackWfAction"};

export function texprBuybackWfAction(): ADL.ATypeExpr<BuybackWfAction> {
  return {value : {typeRef : {kind: "reference", value : snBuybackWfAction}, parameters : []}};
}

export interface TransportWfConfirmDeliveryAction {
  stockGainReq: StockAdjustmentReq;
  StockLossReq: StockAdjustmentReq;
}

export function makeTransportWfConfirmDeliveryAction(
  input: {
    stockGainReq: StockAdjustmentReq,
    StockLossReq: StockAdjustmentReq,
  }
): TransportWfConfirmDeliveryAction {
  return {
    stockGainReq: input.stockGainReq,
    StockLossReq: input.StockLossReq,
  };
}

const TransportWfConfirmDeliveryAction_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"stockGainReq","default":{"kind":"nothing"},"name":"stockGainReq","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"StockAdjustmentReq"}},"parameters":[]}},{"annotations":[],"serializedName":"StockLossReq","default":{"kind":"nothing"},"name":"StockLossReq","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"StockAdjustmentReq"}},"parameters":[]}}]}},"name":"TransportWfConfirmDeliveryAction","version":{"kind":"nothing"}}};

export const snTransportWfConfirmDeliveryAction: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"TransportWfConfirmDeliveryAction"};

export function texprTransportWfConfirmDeliveryAction(): ADL.ATypeExpr<TransportWfConfirmDeliveryAction> {
  return {value : {typeRef : {kind: "reference", value : snTransportWfConfirmDeliveryAction}, parameters : []}};
}

export interface TransportWfProduct {
  productId: ferovinum_app_db.ProductId;
  quantity: ferovinum_app_db.NumberOfUnits;
  rotationNumber: (string|null);
  price: ferovinum_app_types.Decimal;
  currency: ferovinum_app_db.Currency;
  singlesPerCase: (number|null);
}

export function makeTransportWfProduct(
  input: {
    productId: ferovinum_app_db.ProductId,
    quantity: ferovinum_app_db.NumberOfUnits,
    rotationNumber: (string|null),
    price: ferovinum_app_types.Decimal,
    currency: ferovinum_app_db.Currency,
    singlesPerCase: (number|null),
  }
): TransportWfProduct {
  return {
    productId: input.productId,
    quantity: input.quantity,
    rotationNumber: input.rotationNumber,
    price: input.price,
    currency: input.currency,
    singlesPerCase: input.singlesPerCase,
  };
}

const TransportWfProduct_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"productId","default":{"kind":"nothing"},"name":"productId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ProductId"}},"parameters":[]}},{"annotations":[],"serializedName":"quantity","default":{"kind":"nothing"},"name":"quantity","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"NumberOfUnits"}},"parameters":[]}},{"annotations":[],"serializedName":"rotationNumber","default":{"kind":"nothing"},"name":"rotationNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"price","default":{"kind":"nothing"},"name":"price","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.types","name":"Decimal"}},"parameters":[]}},{"annotations":[],"serializedName":"currency","default":{"kind":"nothing"},"name":"currency","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"Currency"}},"parameters":[]}},{"annotations":[],"serializedName":"singlesPerCase","default":{"kind":"nothing"},"name":"singlesPerCase","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}]}}]}},"name":"TransportWfProduct","version":{"kind":"nothing"}}};

export const snTransportWfProduct: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"TransportWfProduct"};

export function texprTransportWfProduct(): ADL.ATypeExpr<TransportWfProduct> {
  return {value : {typeRef : {kind: "reference", value : snTransportWfProduct}, parameters : []}};
}

export interface TransportWfData {
  reference: common_strings.StringNE;
  startingLocationId: ferovinum_app_db.StorageLocationId;
  destinationLocationId: ferovinum_app_db.StorageLocationId;
  deliveryOption: StockMovementDeliveryOption;
  stockToMove: TransportWfProduct[];
  deliveryStatuses: ferovinum_app_db.DeliveryStatus[];
}

export function makeTransportWfData(
  input: {
    reference: common_strings.StringNE,
    startingLocationId: ferovinum_app_db.StorageLocationId,
    destinationLocationId: ferovinum_app_db.StorageLocationId,
    deliveryOption: StockMovementDeliveryOption,
    stockToMove: TransportWfProduct[],
    deliveryStatuses: ferovinum_app_db.DeliveryStatus[],
  }
): TransportWfData {
  return {
    reference: input.reference,
    startingLocationId: input.startingLocationId,
    destinationLocationId: input.destinationLocationId,
    deliveryOption: input.deliveryOption,
    stockToMove: input.stockToMove,
    deliveryStatuses: input.deliveryStatuses,
  };
}

const TransportWfData_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"reference","default":{"kind":"nothing"},"name":"reference","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"startingLocationId","default":{"kind":"nothing"},"name":"startingLocationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"StorageLocationId"}},"parameters":[]}},{"annotations":[],"serializedName":"destinationLocationId","default":{"kind":"nothing"},"name":"destinationLocationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"StorageLocationId"}},"parameters":[]}},{"annotations":[],"serializedName":"deliveryOption","default":{"kind":"nothing"},"name":"deliveryOption","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"StockMovementDeliveryOption"}},"parameters":[]}},{"annotations":[],"serializedName":"stockToMove","default":{"kind":"nothing"},"name":"stockToMove","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"TransportWfProduct"}},"parameters":[]}]}},{"annotations":[],"serializedName":"deliveryStatuses","default":{"kind":"nothing"},"name":"deliveryStatuses","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"DeliveryStatus"}},"parameters":[]}]}}]}},"name":"TransportWfData","version":{"kind":"nothing"}}};

export const snTransportWfData: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"TransportWfData"};

export function texprTransportWfData(): ADL.ATypeExpr<TransportWfData> {
  return {value : {typeRef : {kind: "reference", value : snTransportWfData}, parameters : []}};
}

export type TransportWfState = 'awaiting_delivery' | 'collected' | 'delivered' | 'delivery_confirmed';
export const valuesTransportWfState : TransportWfState[] = ['awaiting_delivery', 'collected', 'delivered', 'delivery_confirmed'];

const TransportWfState_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"awaiting_delivery","default":{"kind":"nothing"},"name":"awaiting_delivery","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"collected","default":{"kind":"nothing"},"name":"collected","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"delivered","default":{"kind":"nothing"},"name":"delivered","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"delivery_confirmed","default":{"kind":"nothing"},"name":"delivery_confirmed","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"TransportWfState","version":{"kind":"nothing"}}};

export const snTransportWfState: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"TransportWfState"};

export function texprTransportWfState(): ADL.ATypeExpr<TransportWfState> {
  return {value : {typeRef : {kind: "reference", value : snTransportWfState}, parameters : []}};
}

export interface TransportWfAction_Request {
  kind: 'request';
  value: TransportWfData;
}
export interface TransportWfAction_Collect {
  kind: 'collect';
}
export interface TransportWfAction_Deliver {
  kind: 'deliver';
}
export interface TransportWfAction_Confirm_delivery {
  kind: 'confirm_delivery';
}

export type TransportWfAction = TransportWfAction_Request | TransportWfAction_Collect | TransportWfAction_Deliver | TransportWfAction_Confirm_delivery;

export interface TransportWfActionOpts {
  request: TransportWfData;
  collect: null;
  deliver: null;
  confirm_delivery: null;
}

export function makeTransportWfAction<K extends keyof TransportWfActionOpts>(kind: K, value: TransportWfActionOpts[K]) { return {kind, value}; }

const TransportWfAction_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"request","default":{"kind":"nothing"},"name":"request","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"TransportWfData"}},"parameters":[]}},{"annotations":[],"serializedName":"collect","default":{"kind":"nothing"},"name":"collect","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"deliver","default":{"kind":"nothing"},"name":"deliver","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"confirm_delivery","default":{"kind":"nothing"},"name":"confirm_delivery","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"TransportWfAction","version":{"kind":"nothing"}}};

export const snTransportWfAction: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"TransportWfAction"};

export function texprTransportWfAction(): ADL.ATypeExpr<TransportWfAction> {
  return {value : {typeRef : {kind: "reference", value : snTransportWfAction}, parameters : []}};
}

export interface TransportWfError_Request {
  kind: 'request';
  value: common_strings.StringNE;
}

export type TransportWfError = TransportWfError_Request;

export interface TransportWfErrorOpts {
  request: common_strings.StringNE;
}

export function makeTransportWfError<K extends keyof TransportWfErrorOpts>(kind: K, value: TransportWfErrorOpts[K]) { return {kind, value}; }

const TransportWfError_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"request","default":{"kind":"nothing"},"name":"request","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}]}},"name":"TransportWfError","version":{"kind":"nothing"}}};

export const snTransportWfError: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"TransportWfError"};

export function texprTransportWfError(): ADL.ATypeExpr<TransportWfError> {
  return {value : {typeRef : {kind: "reference", value : snTransportWfError}, parameters : []}};
}

export interface CreatePositiveStockAdjustmentReq {
  storageLocationId: ferovinum_app_db.StorageLocationId;
  adjustmentsToCreate: ferovinum_app_common.ProductIdQuantity[];
  comments: (common_strings.StringNE|null);
  /**
   * Reference number will be assigned by the backend if not supplied
   */
  referenceNumber: (common_strings.StringNE|null);
}

export function makeCreatePositiveStockAdjustmentReq(
  input: {
    storageLocationId: ferovinum_app_db.StorageLocationId,
    adjustmentsToCreate: ferovinum_app_common.ProductIdQuantity[],
    comments: (common_strings.StringNE|null),
    referenceNumber: (common_strings.StringNE|null),
  }
): CreatePositiveStockAdjustmentReq {
  return {
    storageLocationId: input.storageLocationId,
    adjustmentsToCreate: input.adjustmentsToCreate,
    comments: input.comments,
    referenceNumber: input.referenceNumber,
  };
}

const CreatePositiveStockAdjustmentReq_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"storageLocationId","default":{"kind":"nothing"},"name":"storageLocationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"StorageLocationId"}},"parameters":[]}},{"annotations":[],"serializedName":"adjustmentsToCreate","default":{"kind":"nothing"},"name":"adjustmentsToCreate","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.common","name":"ProductIdQuantity"}},"parameters":[]}]}},{"annotations":[],"serializedName":"comments","default":{"kind":"nothing"},"name":"comments","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[{"value":"Reference number will be assigned by the backend if not supplied\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"referenceNumber","default":{"kind":"nothing"},"name":"referenceNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}}]}},"name":"CreatePositiveStockAdjustmentReq","version":{"kind":"nothing"}}};

export const snCreatePositiveStockAdjustmentReq: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"CreatePositiveStockAdjustmentReq"};

export function texprCreatePositiveStockAdjustmentReq(): ADL.ATypeExpr<CreatePositiveStockAdjustmentReq> {
  return {value : {typeRef : {kind: "reference", value : snCreatePositiveStockAdjustmentReq}, parameters : []}};
}

export interface StockGainWfData {
  stockGainReq: CreatePositiveStockAdjustmentReq;
  positiveStockAdjustmentId: common_db.DbKey<ferovinum_app_db.PositiveStockAdjustment>;
}

export function makeStockGainWfData(
  input: {
    stockGainReq: CreatePositiveStockAdjustmentReq,
    positiveStockAdjustmentId: common_db.DbKey<ferovinum_app_db.PositiveStockAdjustment>,
  }
): StockGainWfData {
  return {
    stockGainReq: input.stockGainReq,
    positiveStockAdjustmentId: input.positiveStockAdjustmentId,
  };
}

const StockGainWfData_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"stockGainReq","default":{"kind":"nothing"},"name":"stockGainReq","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"CreatePositiveStockAdjustmentReq"}},"parameters":[]}},{"annotations":[],"serializedName":"positiveStockAdjustmentId","default":{"kind":"nothing"},"name":"positiveStockAdjustmentId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"PositiveStockAdjustment"}},"parameters":[]}]}}]}},"name":"StockGainWfData","version":{"kind":"nothing"}}};

export const snStockGainWfData: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"StockGainWfData"};

export function texprStockGainWfData(): ADL.ATypeExpr<StockGainWfData> {
  return {value : {typeRef : {kind: "reference", value : snStockGainWfData}, parameters : []}};
}

export type StockGainWfState = 'completed';
export const valuesStockGainWfState : StockGainWfState[] = ['completed'];

const StockGainWfState_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"completed","default":{"kind":"nothing"},"name":"completed","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"StockGainWfState","version":{"kind":"nothing"}}};

export const snStockGainWfState: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"StockGainWfState"};

export function texprStockGainWfState(): ADL.ATypeExpr<StockGainWfState> {
  return {value : {typeRef : {kind: "reference", value : snStockGainWfState}, parameters : []}};
}

export interface StockGainWfAction_Request {
  kind: 'request';
  value: CreatePositiveStockAdjustmentReq;
}

export type StockGainWfAction = StockGainWfAction_Request;

export interface StockGainWfActionOpts {
  request: CreatePositiveStockAdjustmentReq;
}

export function makeStockGainWfAction<K extends keyof StockGainWfActionOpts>(kind: K, value: StockGainWfActionOpts[K]) { return {kind, value}; }

const StockGainWfAction_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"request","default":{"kind":"nothing"},"name":"request","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"CreatePositiveStockAdjustmentReq"}},"parameters":[]}}]}},"name":"StockGainWfAction","version":{"kind":"nothing"}}};

export const snStockGainWfAction: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"StockGainWfAction"};

export function texprStockGainWfAction(): ADL.ATypeExpr<StockGainWfAction> {
  return {value : {typeRef : {kind: "reference", value : snStockGainWfAction}, parameters : []}};
}

export type StockGainWfReferenceNumberExistsError = common_strings.StringNE;

const StockGainWfReferenceNumberExistsError_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"newtype_","value":{"typeParams":[],"default":{"kind":"nothing"},"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}},"name":"StockGainWfReferenceNumberExistsError","version":{"kind":"nothing"}}};

export const snStockGainWfReferenceNumberExistsError: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"StockGainWfReferenceNumberExistsError"};

export function texprStockGainWfReferenceNumberExistsError(): ADL.ATypeExpr<StockGainWfReferenceNumberExistsError> {
  return {value : {typeRef : {kind: "reference", value : snStockGainWfReferenceNumberExistsError}, parameters : []}};
}

export interface StockGainWfError_ReferenceNumberExists {
  kind: 'referenceNumberExists';
  value: StockGainWfReferenceNumberExistsError;
}

export type StockGainWfError = StockGainWfError_ReferenceNumberExists;

export interface StockGainWfErrorOpts {
  referenceNumberExists: StockGainWfReferenceNumberExistsError;
}

export function makeStockGainWfError<K extends keyof StockGainWfErrorOpts>(kind: K, value: StockGainWfErrorOpts[K]) { return {kind, value}; }

const StockGainWfError_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"referenceNumberExists","default":{"kind":"nothing"},"name":"referenceNumberExists","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"StockGainWfReferenceNumberExistsError"}},"parameters":[]}}]}},"name":"StockGainWfError","version":{"kind":"nothing"}}};

export const snStockGainWfError: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"StockGainWfError"};

export function texprStockGainWfError(): ADL.ATypeExpr<StockGainWfError> {
  return {value : {typeRef : {kind: "reference", value : snStockGainWfError}, parameters : []}};
}

export interface StockAdjustmentEntity_RotationNumber {
  kind: 'rotationNumber';
  value: string;
}
export interface StockAdjustmentEntity_ProductId {
  kind: 'productId';
  value: ferovinum_app_db.ProductId;
}

export type StockAdjustmentEntity = StockAdjustmentEntity_RotationNumber | StockAdjustmentEntity_ProductId;

export interface StockAdjustmentEntityOpts {
  /**
   * A rotation number linked to a product to deplete
   */
  rotationNumber: string;
  /**
   * A product ID, the backend will decide on which deal legs to deplete. The
   * product should only belong to a single client
   */
  productId: ferovinum_app_db.ProductId;
}

export function makeStockAdjustmentEntity<K extends keyof StockAdjustmentEntityOpts>(kind: K, value: StockAdjustmentEntityOpts[K]) { return {kind, value}; }

const StockAdjustmentEntity_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[{"value":"A rotation number linked to a product to deplete\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"rotationNumber","default":{"kind":"nothing"},"name":"rotationNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"value":"A product ID, the backend will decide on which deal legs to deplete. The\nproduct should only belong to a single client\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"productId","default":{"kind":"nothing"},"name":"productId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ProductId"}},"parameters":[]}}]}},"name":"StockAdjustmentEntity","version":{"kind":"nothing"}}};

export const snStockAdjustmentEntity: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"StockAdjustmentEntity"};

export function texprStockAdjustmentEntity(): ADL.ATypeExpr<StockAdjustmentEntity> {
  return {value : {typeRef : {kind: "reference", value : snStockAdjustmentEntity}, parameters : []}};
}

export interface StockAdjustmentToCreate {
  stockAdjustmentEntity: StockAdjustmentEntity;
  numberOfUnits: ferovinum_app_db.NumberOfUnits;
}

export function makeStockAdjustmentToCreate(
  input: {
    stockAdjustmentEntity: StockAdjustmentEntity,
    numberOfUnits: ferovinum_app_db.NumberOfUnits,
  }
): StockAdjustmentToCreate {
  return {
    stockAdjustmentEntity: input.stockAdjustmentEntity,
    numberOfUnits: input.numberOfUnits,
  };
}

const StockAdjustmentToCreate_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"stockAdjustmentEntity","default":{"kind":"nothing"},"name":"stockAdjustmentEntity","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"StockAdjustmentEntity"}},"parameters":[]}},{"annotations":[],"serializedName":"numberOfUnits","default":{"kind":"nothing"},"name":"numberOfUnits","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"NumberOfUnits"}},"parameters":[]}}]}},"name":"StockAdjustmentToCreate","version":{"kind":"nothing"}}};

export const snStockAdjustmentToCreate: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"StockAdjustmentToCreate"};

export function texprStockAdjustmentToCreate(): ADL.ATypeExpr<StockAdjustmentToCreate> {
  return {value : {typeRef : {kind: "reference", value : snStockAdjustmentToCreate}, parameters : []}};
}

export interface StockAdjustmentReq {
  storageLocationId: ferovinum_app_db.StorageLocationId;
  reimbursingCosts: boolean;
  comment: (string|null);
  reference: (string|null);
  stockDifferences: StockAdjustmentToCreate[];
}

export function makeStockAdjustmentReq(
  input: {
    storageLocationId: ferovinum_app_db.StorageLocationId,
    reimbursingCosts: boolean,
    comment: (string|null),
    reference: (string|null),
    stockDifferences: StockAdjustmentToCreate[],
  }
): StockAdjustmentReq {
  return {
    storageLocationId: input.storageLocationId,
    reimbursingCosts: input.reimbursingCosts,
    comment: input.comment,
    reference: input.reference,
    stockDifferences: input.stockDifferences,
  };
}

const StockAdjustmentReq_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"storageLocationId","default":{"kind":"nothing"},"name":"storageLocationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"StorageLocationId"}},"parameters":[]}},{"annotations":[],"serializedName":"reimbursingCosts","default":{"kind":"nothing"},"name":"reimbursingCosts","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"comment","default":{"kind":"nothing"},"name":"comment","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"reference","default":{"kind":"nothing"},"name":"reference","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"stockDifferences","default":{"kind":"nothing"},"name":"stockDifferences","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"StockAdjustmentToCreate"}},"parameters":[]}]}}]}},"name":"StockAdjustmentReq","version":{"kind":"nothing"}}};

export const snStockAdjustmentReq: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"StockAdjustmentReq"};

export function texprStockAdjustmentReq(): ADL.ATypeExpr<StockAdjustmentReq> {
  return {value : {typeRef : {kind: "reference", value : snStockAdjustmentReq}, parameters : []}};
}

export interface StockLossWfData {
  stockLossReq: StockAdjustmentReq;
  negativeStockAdjustmentId: common_db.DbKey<ferovinum_app_db.NegativeStockAdjustment>;
  additionalCosts: (ferovinum_app_db.NegativeStockAdjustmentAdditionalCosts|null);
}

export function makeStockLossWfData(
  input: {
    stockLossReq: StockAdjustmentReq,
    negativeStockAdjustmentId: common_db.DbKey<ferovinum_app_db.NegativeStockAdjustment>,
    additionalCosts: (ferovinum_app_db.NegativeStockAdjustmentAdditionalCosts|null),
  }
): StockLossWfData {
  return {
    stockLossReq: input.stockLossReq,
    negativeStockAdjustmentId: input.negativeStockAdjustmentId,
    additionalCosts: input.additionalCosts,
  };
}

const StockLossWfData_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"stockLossReq","default":{"kind":"nothing"},"name":"stockLossReq","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"StockAdjustmentReq"}},"parameters":[]}},{"annotations":[],"serializedName":"negativeStockAdjustmentId","default":{"kind":"nothing"},"name":"negativeStockAdjustmentId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"NegativeStockAdjustment"}},"parameters":[]}]}},{"annotations":[],"serializedName":"additionalCosts","default":{"kind":"nothing"},"name":"additionalCosts","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"NegativeStockAdjustmentAdditionalCosts"}},"parameters":[]}]}}]}},"name":"StockLossWfData","version":{"kind":"nothing"}}};

export const snStockLossWfData: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"StockLossWfData"};

export function texprStockLossWfData(): ADL.ATypeExpr<StockLossWfData> {
  return {value : {typeRef : {kind: "reference", value : snStockLossWfData}, parameters : []}};
}

export type StockLossWfState = 'requested' | 'completed';
export const valuesStockLossWfState : StockLossWfState[] = ['requested', 'completed'];

const StockLossWfState_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"requested","default":{"kind":"nothing"},"name":"requested","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"completed","default":{"kind":"nothing"},"name":"completed","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"StockLossWfState","version":{"kind":"nothing"}}};

export const snStockLossWfState: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"StockLossWfState"};

export function texprStockLossWfState(): ADL.ATypeExpr<StockLossWfState> {
  return {value : {typeRef : {kind: "reference", value : snStockLossWfState}, parameters : []}};
}

export interface StockLossWfAction_Request {
  kind: 'request';
  value: StockAdjustmentReq;
}
export interface StockLossWfAction_Approve {
  kind: 'approve';
  value: ferovinum_app_db.NegativeStockAdjustmentAdditionalCosts;
}

export type StockLossWfAction = StockLossWfAction_Request | StockLossWfAction_Approve;

export interface StockLossWfActionOpts {
  request: StockAdjustmentReq;
  approve: ferovinum_app_db.NegativeStockAdjustmentAdditionalCosts;
}

export function makeStockLossWfAction<K extends keyof StockLossWfActionOpts>(kind: K, value: StockLossWfActionOpts[K]) { return {kind, value}; }

const StockLossWfAction_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"request","default":{"kind":"nothing"},"name":"request","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"StockAdjustmentReq"}},"parameters":[]}},{"annotations":[],"serializedName":"approve","default":{"kind":"nothing"},"name":"approve","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"NegativeStockAdjustmentAdditionalCosts"}},"parameters":[]}}]}},"name":"StockLossWfAction","version":{"kind":"nothing"}}};

export const snStockLossWfAction: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"StockLossWfAction"};

export function texprStockLossWfAction(): ADL.ATypeExpr<StockLossWfAction> {
  return {value : {typeRef : {kind: "reference", value : snStockLossWfAction}, parameters : []}};
}

export type StockLossWfReferenceNumberExistsError = common_strings.StringNE;

const StockLossWfReferenceNumberExistsError_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"newtype_","value":{"typeParams":[],"default":{"kind":"nothing"},"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}},"name":"StockLossWfReferenceNumberExistsError","version":{"kind":"nothing"}}};

export const snStockLossWfReferenceNumberExistsError: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"StockLossWfReferenceNumberExistsError"};

export function texprStockLossWfReferenceNumberExistsError(): ADL.ATypeExpr<StockLossWfReferenceNumberExistsError> {
  return {value : {typeRef : {kind: "reference", value : snStockLossWfReferenceNumberExistsError}, parameters : []}};
}

export interface StockLossWfError_ReferenceNumberExists {
  kind: 'referenceNumberExists';
  value: StockLossWfReferenceNumberExistsError;
}

export type StockLossWfError = StockLossWfError_ReferenceNumberExists;

export interface StockLossWfErrorOpts {
  referenceNumberExists: StockLossWfReferenceNumberExistsError;
}

export function makeStockLossWfError<K extends keyof StockLossWfErrorOpts>(kind: K, value: StockLossWfErrorOpts[K]) { return {kind, value}; }

const StockLossWfError_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"referenceNumberExists","default":{"kind":"nothing"},"name":"referenceNumberExists","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"StockLossWfReferenceNumberExistsError"}},"parameters":[]}}]}},"name":"StockLossWfError","version":{"kind":"nothing"}}};

export const snStockLossWfError: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"StockLossWfError"};

export function texprStockLossWfError(): ADL.ATypeExpr<StockLossWfError> {
  return {value : {typeRef : {kind: "reference", value : snStockLossWfError}, parameters : []}};
}

export interface RequestWorkflowTypes_Stock_movement {
  kind: 'stock_movement';
  value: StockMovementWfState;
}

export type RequestWorkflowTypes = RequestWorkflowTypes_Stock_movement;

export interface RequestWorkflowTypesOpts {
  stock_movement: StockMovementWfState;
}

export function makeRequestWorkflowTypes<K extends keyof RequestWorkflowTypesOpts>(kind: K, value: RequestWorkflowTypesOpts[K]) { return {kind, value}; }

const RequestWorkflowTypes_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"stock_movement","default":{"kind":"nothing"},"name":"stock_movement","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"StockMovementWfState"}},"parameters":[]}}]}},"name":"RequestWorkflowTypes","version":{"kind":"nothing"}}};

export const snRequestWorkflowTypes: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"RequestWorkflowTypes"};

export function texprRequestWorkflowTypes(): ADL.ATypeExpr<RequestWorkflowTypes> {
  return {value : {typeRef : {kind: "reference", value : snRequestWorkflowTypes}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.app.workflow.Workflow" : Workflow_AST,
  "ferovinum.app.workflow.WorkflowId" : WorkflowId_AST,
  "ferovinum.app.workflow.WorkflowHistory" : WorkflowHistory_AST,
  "ferovinum.app.workflow.WfRole" : WfRole_AST,
  "ferovinum.app.workflow.WfData" : WfData_AST,
  "ferovinum.app.workflow.WfState" : WfState_AST,
  "ferovinum.app.workflow.WfAction" : WfAction_AST,
  "ferovinum.app.workflow.WfSuccessResult" : WfSuccessResult_AST,
  "ferovinum.app.workflow.WfResult" : WfResult_AST,
  "ferovinum.app.workflow.WfError" : WfError_AST,
  "ferovinum.app.workflow.StockMovementDeliveryOption" : StockMovementDeliveryOption_AST,
  "ferovinum.app.workflow.StockMovementCollection" : StockMovementCollection_AST,
  "ferovinum.app.workflow.StockMovementDelivery" : StockMovementDelivery_AST,
  "ferovinum.app.workflow.StockMovementReq" : StockMovementReq_AST,
  "ferovinum.app.workflow.StockMovementWfData" : StockMovementWfData_AST,
  "ferovinum.app.workflow.StockMovementWfState" : StockMovementWfState_AST,
  "ferovinum.app.workflow.StockMovementWfAction" : StockMovementWfAction_AST,
  "ferovinum.app.workflow.BuybackOption" : BuybackOption_AST,
  "ferovinum.app.workflow.BuybackCollection" : BuybackCollection_AST,
  "ferovinum.app.workflow.BuybackReq" : BuybackReq_AST,
  "ferovinum.app.workflow.BuybackCreateFromExistingReq" : BuybackCreateFromExistingReq_AST,
  "ferovinum.app.workflow.BuybackMarkAsInvoicedReq" : BuybackMarkAsInvoicedReq_AST,
  "ferovinum.app.workflow.BuybackWfData" : BuybackWfData_AST,
  "ferovinum.app.workflow.BuybackWfState" : BuybackWfState_AST,
  "ferovinum.app.workflow.BuybackWfAction" : BuybackWfAction_AST,
  "ferovinum.app.workflow.TransportWfConfirmDeliveryAction" : TransportWfConfirmDeliveryAction_AST,
  "ferovinum.app.workflow.TransportWfProduct" : TransportWfProduct_AST,
  "ferovinum.app.workflow.TransportWfData" : TransportWfData_AST,
  "ferovinum.app.workflow.TransportWfState" : TransportWfState_AST,
  "ferovinum.app.workflow.TransportWfAction" : TransportWfAction_AST,
  "ferovinum.app.workflow.TransportWfError" : TransportWfError_AST,
  "ferovinum.app.workflow.CreatePositiveStockAdjustmentReq" : CreatePositiveStockAdjustmentReq_AST,
  "ferovinum.app.workflow.StockGainWfData" : StockGainWfData_AST,
  "ferovinum.app.workflow.StockGainWfState" : StockGainWfState_AST,
  "ferovinum.app.workflow.StockGainWfAction" : StockGainWfAction_AST,
  "ferovinum.app.workflow.StockGainWfReferenceNumberExistsError" : StockGainWfReferenceNumberExistsError_AST,
  "ferovinum.app.workflow.StockGainWfError" : StockGainWfError_AST,
  "ferovinum.app.workflow.StockAdjustmentEntity" : StockAdjustmentEntity_AST,
  "ferovinum.app.workflow.StockAdjustmentToCreate" : StockAdjustmentToCreate_AST,
  "ferovinum.app.workflow.StockAdjustmentReq" : StockAdjustmentReq_AST,
  "ferovinum.app.workflow.StockLossWfData" : StockLossWfData_AST,
  "ferovinum.app.workflow.StockLossWfState" : StockLossWfState_AST,
  "ferovinum.app.workflow.StockLossWfAction" : StockLossWfAction_AST,
  "ferovinum.app.workflow.StockLossWfReferenceNumberExistsError" : StockLossWfReferenceNumberExistsError_AST,
  "ferovinum.app.workflow.StockLossWfError" : StockLossWfError_AST,
  "ferovinum.app.workflow.RequestWorkflowTypes" : RequestWorkflowTypes_AST
};
